
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LdsFisFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LdsFis"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"securitiesRequested"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"movableSecurities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MovableSecurityFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"immovableSecurities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImmovableSecurityFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"queries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"query"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reply"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forClient"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"docsIds"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":335}};
    doc.loc.source = {"body":"#import \"./MovableSecurityFragment.graphql\"\n#import \"./ImmovableSecurityFragment.graphql\"\n\nfragment LdsFisFields on LdsFis {\n  id\n  securitiesRequested\n  movableSecurities {\n    ...MovableSecurityFields\n  }\n  immovableSecurities {\n    ...ImmovableSecurityFields\n  }\n  queries {\n    id\n    query\n    reply\n    forClient\n  }\n  docsIds\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./MovableSecurityFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ImmovableSecurityFragment.graphql").definitions));


      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/LdsFisFragment.graphql
// module id = 287
// module chunks = 0